import {
    faArrowLeft,
    faCodeFork,
    faCube,
    faCucumber,
    faDisplay,
    faHardDrive,
    faMicrochip,
    faServer,
    faTrashAlt,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UserfulTooltip } from "userful-chronos-common-ui/dist";
import { ClusterDeviceInfo, IClusterInfo, IConstellationInfo } from "../../../model/CarbonExternalModels";
import { AppSliceActions } from "../../../store/app/appSlice";
import { selectClusterTabsView, useCarbonDispatch, useCarbonSelector } from "../../../store/carbonStore";
import ClustersDropdown from "./clustersDropdown/ClustersDropdown";
import { useEffect, useState } from "react";
import DevicesTable from "../../devices/table/DevicesTable";

import "./ClusterPage.scss";
import { getCPUUsage, getGPUUsage } from "../../../common/functions/formatters";
import { getNumberOfNodes, getTotalNumberOfUClients } from "../utils/clusterNodes";

interface IProps {
    foundObject: { cluster: IClusterInfo; constellation: IConstellationInfo };
}

type TCluster = "OVERVIEW" | "DEVICES";

export default function ClusterPage({ foundObject }: IProps) {
    const clusterView: TCluster = useCarbonSelector(selectClusterTabsView);

    const dispatch = useCarbonDispatch();

    const insertClusterOverview = () => {
        let totalGPULoad = 0;
        let totalCPUUsage = 0;

        let averageGPULoad: number | string = 0;
        let averageCPUUsage: number | string = 0;

        const totalNumberOfDevices = getNumberOfNodes(foundObject.cluster);
        const totalUClients = getTotalNumberOfUClients(foundObject, totalNumberOfDevices);

        if (totalNumberOfDevices > 0) {
            averageGPULoad = Math.round(totalGPULoad / totalNumberOfDevices);
        } else {
            averageGPULoad = "0";
        }
        if (totalNumberOfDevices > 0) {
            averageCPUUsage = Math.round(totalCPUUsage / totalNumberOfDevices);
        } else {
            averageCPUUsage = "0";
        }
        console.info(
            "@@@@@@@@@@@@ totalUClients: " +
                totalUClients +
                ", totalGPULoad: " +
                totalGPULoad +
                ", totalCPUUsage: " +
                totalCPUUsage,
        );

        return (
            <div className="cluster-overview">
                <div className="cluster-overview-container">
                    <p className="cluster-container-header-text">Mapping Groups</p>
                    <div className="cluster-container-body">
                        <FontAwesomeIcon icon={faCodeFork} />
                        <p>{foundObject.cluster.mappingGroups}</p>
                    </div>
                </div>
                <div className="cluster-overview-container">
                    <p className="cluster-container-header-text">Nodes</p>
                    <div className="cluster-container-body">
                        <FontAwesomeIcon icon={faServer} />
                        <p>{totalNumberOfDevices}</p>
                    </div>
                </div>
                <div className="cluster-overview-container">
                    <p className="cluster-container-header-text">End-Points</p>
                    <div className="cluster-container-body">
                        <FontAwesomeIcon icon={faHardDrive} />
                        <p>{totalUClients}</p>
                    </div>
                </div>
                <div className="cluster-overview-container">
                    <p className="cluster-container-header-text">Active Sources</p>
                    <div className="cluster-container-body">
                        <FontAwesomeIcon icon={faCube} />
                        <p>{foundObject.cluster.activeSources}</p>
                    </div>
                </div>
                <div className="cluster-overview-container">
                    <p className="cluster-container-header-text">Active Destinations</p>
                    <div className="cluster-container-body">
                        <FontAwesomeIcon icon={faDisplay} />
                        <p>{foundObject.cluster.activeDestinations}</p>
                    </div>
                </div>
                <div className="cluster-overview-container">
                    <p className="cluster-container-header-text">Average GPU Load</p>
                    <div className="cluster-container-body">
                        <FontAwesomeIcon icon={faMicrochip} />
                        <p>{averageGPULoad}%</p>
                    </div>
                </div>
                <div className="cluster-overview-container">
                    <p className="cluster-container-header-text">Average CPU Usage</p>
                    <div className="cluster-container-body">
                        <FontAwesomeIcon icon={faMicrochip} />
                        <p>{averageCPUUsage}%</p>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="genericWrapper">
            <div className="actionsBar">
                <div className="cluster normalGap">
                    <UserfulTooltip title={"Return to Clusters"}>
                        <button
                            className="iconButton"
                            onClick={(e) => {
                                dispatch(
                                    AppSliceActions.setAppView({
                                        type: "CONSTELLATION",
                                        id: foundObject.constellation.definition.id,
                                    }),
                                );
                            }}
                        >
                            <FontAwesomeIcon icon={faArrowLeft} />
                        </button>
                    </UserfulTooltip>
                    <ClustersDropdown foundObject={foundObject} />
                    <div className="multiStateWrapper">
                        <div
                            className={`mSbutton ${clusterView === "OVERVIEW" ? "active" : ""}`}
                            onClick={(e) => {
                                dispatch(AppSliceActions.setClusterTabsView("OVERVIEW"));
                            }}
                        >
                            <p>Content Overview</p>
                        </div>

                        <div
                            className={`mSbutton ${clusterView === "DEVICES" ? "active" : ""}`}
                            onClick={(e) => {
                                dispatch(AppSliceActions.setClusterTabsView("DEVICES"));
                            }}
                        >
                            <p>Nodes</p>
                        </div>
                    </div>
                </div>
                <div className="cluster normalGap">
                    {/* <UserfulTooltip title={"Delete"}>
                        <button className="iconButton">
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </button>
                    </UserfulTooltip> */}
                </div>
            </div>
            <div className="cluster-body">
                {clusterView === "OVERVIEW" && insertClusterOverview()}
                {clusterView === "DEVICES" && <DevicesTable foundObject={foundObject} />}
            </div>
        </div>
    );
}
